import { z } from 'zod';
import { POKEMON_TYPES } from '../../../types';

export const pokemonTypeSchema = z.enum(POKEMON_TYPES);

export const pokemonBaseStatsSchema = z.object({
  hp: z.number().int().min(1).max(255),
  attack: z.number().int().min(1).max(255),
  defense: z.number().int().min(1).max(255),
  spAttack: z.number().int().min(1).max(255),
  spDefense: z.number().int().min(1).max(255),
  speed: z.number().int().min(1).max(255),
});

export const pokemonSpeciesSchema = z.object({
  dataVersion: z.number().int().positive(),
  id: z.string().min(1),
  name: z.string().min(1),
  types: z.array(pokemonTypeSchema).min(1).max(2),
  baseStats: pokemonBaseStatsSchema,
  learnsetMoveIds: z.array(z.string().min(1)),
});

export type PokemonBaseStats = z.infer<typeof pokemonBaseStatsSchema>;
export type PokemonSpecies = z.infer<typeof pokemonSpeciesSchema>;
